<template>
    <div class="animated fadeIn">
        <div class="app flex-row align-items-center">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col>
                        <Request
                                ref="request"
                                :onRequestSuccess="onRequestSuccess"
                                root="/contract/reading">
                            <slot slot="body">
                                <div v-html="dataPreview"></div>
                                <div class="contract-box">
                                    <CForm v-if="dataFormStructure !== false" ref="form" :structure="dataFormStructure"></CForm>
                                </div>
                            </slot>
                        </Request>

                        <div class="text-center">
                            <b-button-group class="mr-2 mt-4">
                                <b-button @click="onAcceptClick" variant="success">{{Core.Definition.getDefinition('Accepter')}}</b-button>
                                <b-button @click="onDeclineClick" variant="danger">{{Core.Definition.getDefinition('Refuser')}}</b-button>
                            </b-button-group>
                        </div>

                    </b-col>
                </b-row>
            </div>
        </div>

    </div>
</template>

<script>
    import Request from '../../components/Request'
    import CForm from '../../components/CForm'
    export default {
        name: 'ContractPreview',
        components: {
            Request,
            CForm
        },
        mounted() {
            if (this.$route.params.accessKey !== undefined) {
                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('GET')
                this.$refs.request.addArg('accessKey', this.$route.params.accessKey)
                this.$refs.request.request()
            }
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataPreview: '',
                dataForm: {},
                dataFormStructure: false
            }
        },
        methods: {
            onRequestSuccess(data) {
                if (data.form !== undefined) {
                    this.dataForm = data.form
                }
                if (data.formStructure !== undefined) {
                    this.dataFormStructure = data.formStructure
                }
                if (data.form !== undefined) {
                    this.dataForm = data.form
                }
                if (data.preview !== undefined) {
                    this.dataPreview = data.preview
                }
            },
            onAcceptClick() {
                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('POST')
                this.$refs.request.addArg('accessKey', this.$route.params.accessKey)
                this.$refs.request.addArg('status', Mantle.Contract.statusAccepted)
                this.$refs.request.request()
            },
            onDeclineClick() {
                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('POST')
                this.$refs.request.addArg('accessKey', this.$route.params.accessKey)
                this.$refs.request.addArg('status', Mantle.Contract.statusDeclined)
                this.$refs.request.request()
            }
        }
    }
</script>
